module.exports = __webpack_public_path__ + "static/media/icon_38.58ef2161.svg";